import routePointToJson from "../route_point/mapper_to_json";

export default function createRouteDataToJson(createRouteData) {
    return {
        "company_id": parseInt(createRouteData.companyId),
        'route_points': createRouteData.routePoints.map((point) => routePointToJson(point)),
        'description': createRouteData.description,
        'verified': createRouteData.verified,
    }
}
